import { gql } from '@apollo/client';

export const getConsentFormIdentifiers = gql`
  query getConsentFormIdentifiers($consentTypeId: ID!) {
    consentFormIdentifiers(consentTypeId: $consentTypeId)
  }
`;
